document.addEventListener('turbolinks:load', () => {
    const sidebarAppToggle = $(".sidebarAppToggle")
    const sidebarAppContainer = $(".sidebarAppContainer")
    const sidebarCollapseApp = $(".sidebarCollapseApp")
    const sidebarExpandApp = $(".sidebarExpandApp")

    const sidebarPwaToggle = $(".sidebarPwaToggle")
    const sidebarPwaContainer = $(".sidebarPwaContainer")
    const sidebarCollapsePwa = $(".sidebarCollapsePwa")
    const sidebarExpandPwa = $(".sidebarExpandPwa")

    if (sidebarAppToggle.length > 0 && sidebarAppContainer.length > 0 && sidebarCollapseApp.length > 0 && sidebarExpandApp.length > 0) {
        sidebarAppToggle.click(() => {toggleContainer('app')})
    }
    if (sidebarPwaToggle.length > 0 && sidebarPwaContainer.length > 0 && sidebarCollapsePwa.length > 0 && sidebarExpandPwa.length > 0) {
        sidebarPwaToggle.click(() => {toggleContainer('pwa')})
    }

    function toggleContainer(target) {
        let containers, collapseSvg, expandSvg
        // set container and svg to the elements that needs changes
        if (target === "app") {
            containers = sidebarAppContainer
            collapseSvg = sidebarCollapseApp
            expandSvg = sidebarExpandApp
        } else if (target === "pwa") {
            containers = sidebarPwaContainer
            collapseSvg = sidebarCollapsePwa
            expandSvg = sidebarExpandPwa
        } else {
            return
        }
        // toggle elements
        if (containers[0].classList.contains('hidden')) {
            containers.removeClass('hidden')
            collapseSvg.removeClass('hidden')
            expandSvg.addClass('hidden')
        } else {
            containers.addClass('hidden')
            collapseSvg.addClass('hidden')
            expandSvg.removeClass('hidden')
        }
    }
})